import { render, staticRenderFns } from "./SearchDetailComponent.vue?vue&type=template&id=6cdc3466&scoped=true"
import script from "./SearchDetailComponent.vue?vue&type=script&lang=js"
export * from "./SearchDetailComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cdc3466",
  null
  
)

export default component.exports